/* Axiom Supply — shared vehicle fitment dataset (SINGLE SOURCE OF TRUTH).
   Consumed by the homepage search (vehicle-search.js) AND the product-page
   fitment checker (product-fitment.js). Load AFTER polaris-bearing-fitment.js
   (Polaris models are merged in here from window.AXIOM_POLARIS_BEARING).

   Collection-based makes route to a fitment COLLECTION handle; Polaris routes
   to the wheel-bearing PRODUCT (prod:true) unless the model has its own
   fitment collection (see POLARIS_COLLECTIONS). A product "fits" a
   collection-based vehicle iff that collection handle is in the product's
   `product.collections`. See docs/vehicle-search.md.
   Last synced to store collections: 2026-09-28. */
(function () {
  if (window.AXIOM_FITMENT) return; // idempotent (snippet may load this twice)

  function F(make, model, trim, start, end, handle) {
    return { make: make, model: model, trim: trim, start: start, end: end, handle: handle };
  }

  var DATA = [
    // RAM 1500 (added 2026-09-28)
    F('RAM', '1500', '3rd Gen', 2002, 2008, '2002-2008-ram-truck-3rd-gen-1500'),
    F('RAM', '1500', '4th Gen', 2009, 2018, '2009-2018-ram-truck-4th-gen-1500'),
    F('RAM', '1500', '5th Gen', 2019, 2026, '2019-2026-ram-truck-5th-gen-1500'),
    // RAM 2500 / 3500
    F('RAM', '2500 / 3500', '2nd Gen', 1994, 2002, '1994-2002-ram-truck-1st-gen-2500-3500'),
    F('RAM', '2500 / 3500', '3rd Gen', 2003, 2009, '2003-2009-2nd-gen-ram-truck-2500-3500'),
    F('RAM', '2500 / 3500', '4th Gen', 2010, 2018, '2010-2018-3rd-gen-ram-truck-2500-3500'),
    F('RAM', '2500 / 3500', '5th Gen', 2019, 2026, '2019-2026-ram-truck-4th-gen-2500-3500'),
    // Ford F-150 (10th-13th Gen collections added 2026-09-28; the old
    // 2015-2017-ford-f150 + 2017-2020-gen-2-raptor-copy collections were deleted)
    F('Ford', 'F-150', '10th Gen', 1997, 2003, '1997-2003-ford-f150-10th-gen'),
    F('Ford', 'F-150', '11th Gen', 2004, 2008, '2004-2008-ford-f150-11th-gen'),
    F('Ford', 'F-150', '12th Gen', 2009, 2014, '2009-2014-ford-f150-12th-gen'),
    F('Ford', 'F-150', '13th Gen', 2015, 2020, '2015-2020-ford-f150-13th-gen'),
    F('Ford', 'F-150', '14th Gen', 2021, 2026, '2021-2026-ford-f150'),
    // Ford Raptor
    F('Ford', 'Raptor', 'Gen 1', 2010, 2014, '2010-2014-gen-1-raptor'),
    F('Ford', 'Raptor', 'Gen 2', 2017, 2020, '2017-2020-gen-2-raptor'),
    F('Ford', 'Raptor', 'Gen 3', 2021, 2026, '2021-2026-gen-3-raptor'),
    F('Ford', 'Raptor R', 'Raptor R', 2023, 2026, '2023-2026-raptor-r'),
    // Ford Super Duty
    F('Ford', 'Super Duty F-250/F-350', "'99-'04", 1999, 2004, '1999-2004-super-duty-excursion-f250-f350'),
    F('Ford', 'Super Duty F-250/F-350', "'05-'10", 2005, 2010, '2005-2010-super-duty-f250-f350'),
    F('Ford', 'Super Duty F-250/F-350', "'11-'16", 2011, 2016, '2011-2016-super-duty-f250-f350'),
    F('Ford', 'Super Duty F-250/F-350', "'17-'22", 2017, 2022, '2017-2022-super-duty-f250-f350'),
    F('Ford', 'Super Duty F-250/F-350', "'23-'26", 2023, 2026, '2023-2026-super-duty-f250-f350'),
    F('Ford', 'Super Duty F-450/F-550', '', 2017, 2026, '2017-2026-super-duty-f450-f550'), // added 2026-09-28
    // Ford Bronco
    F('Ford', 'Bronco', 'Sasquatch', 2021, 2026, '2021-2026-ford-bronco-sasquatch'),
    F('Ford', 'Bronco', 'Non-Sasquatch', 2021, 2026, '2021-2026-ford-bronco-non-sasquatch'),
    F('Ford', 'Bronco', 'Bronco Raptor', 2022, 2026, '2022-2026-ford-bronco-raptor'),
    // Ford Ranger
    F('Ford', 'Ranger', '', 2019, 2026, '2019-2026-ford-ranger'),
    // Chevy / GMC 1500
    F('Chevy / GMC', '1500 (6-Lug)', 'OBS K-Series', 1988, 1999, '1999-2006-chevy-gmc-1500-6-lug-truck-copy'),
    F('Chevy / GMC', '1500 (6-Lug)', 'GMT800', 1999, 2006, '1999-2006-chevy-gmc-1500-6-lug-truck'),
    F('Chevy / GMC', '1500 (6-Lug)', 'GMT900 / K2XX', 2007, 2018, '2007-2018-chevy-gmc-1500-6-lug-truck'),
    F('Chevy / GMC', '1500 (6-Lug)', 'T1XX', 2019, 2025, '2019-2025-chevy-gmc-1500-6-lug-truck'),
    // Chevy / GMC 2500-3500 HD
    F('Chevy / GMC', '2500 / 3500 HD', 'GMT800', 2001, 2010, '2001-2010-chevy-gmc-2500-3500-hd-truck'),
    F('Chevy / GMC', '2500 / 3500 HD', 'GMT900 / K2XX', 2011, 2019, '2011-2019-chevy-gmc-2500-3500-hd-truck'),
    F('Chevy / GMC', '2500 / 3500 HD', 'T1XX', 2020, 2026, '2020-2026-chevy-gmc-2500-3500-hd-truck'),
    // Chevy / GMC Colorado / Canyon (added 2026-09-28)
    F('Chevy / GMC', 'Colorado / Canyon', '2nd Gen', 2015, 2022, '2015-2022-colorado-canyon-2nd-gen'),
    // Jeep
    F('Jeep', 'Wrangler', 'YJ', 1987, 1995, '1990-1999-yj-jeep-wrangler'),
    F('Jeep', 'Wrangler', 'TJ', 1997, 2006, '1997-2006-tj-jeep-wrangler'),
    F('Jeep', 'Wrangler', 'JK', 2007, 2018, '2007-2018-jk-jeep-wrangler'),
    F('Jeep', 'Wrangler', 'JL', 2018, 2026, '2018-2026-jl-jeep-wrangler'),
    F('Jeep', 'Cherokee', 'XJ', 1984, 2001, '1984-2001-xj-jeep-cherokee'),
    F('Jeep', 'Gladiator', 'JT', 2020, 2026, '2020-2026-jt-jeep-gladiator'),
    // Toyota
    F('Toyota', 'Tacoma', '2nd Gen', 2005, 2015, '2005-2015-toyota-tacoma-2nd-gen'),
    F('Toyota', 'Tacoma', '3rd Gen', 2016, 2023, '2016-2023-toyota-tacoma-3rd-gen'),
    F('Toyota', '4Runner', '4th Gen', 2003, 2009, '2003-2009-toyota-4runner-4th-gen'),
    F('Toyota', '4Runner', '5th Gen', 2010, 2024, '2010-2024-toyota-4runner-5th-gen'),
    F('Toyota', 'Tundra', '2nd Gen', 2007, 2021, '2007-2021-toyota-tundra-2nd-gen'),
    F('Toyota', 'Sequoia', '2nd Gen', 2008, 2022, '2008-2022-toyota-sequoia-2nd-gen'),
    F('Toyota', 'FJ Cruiser', '', 2007, 2014, '2007-2014-toyota-fj-cruiser'),
    // Lexus
    F('Lexus', 'GX470 / GX460', '', 2003, 2019, '2003-2019-lexus-gx470-gx460'),
    // Hummer
    F('Hummer', 'H2', 'H2', 2003, 2009, '2003-2009-hummer-h2'),
    // Can-Am
    F('Can-Am', 'Maverick', 'X3', 2017, 2026, '2017-2026cam-ammaverickx3'),
    F('Can-Am', 'Maverick', 'Maverick R', 2024, 2026, '2024-2026-cam-am-maverick-r'),
    // Kawasaki
    F('Kawasaki', 'Teryx', 'KRX', 2020, 2026, '2020-2026-kawasaki-teryx-krx'),
    F('Kawasaki', 'Teryx', 'H2', 2026, 2026, 'kawasaki-teryx-h2')
  ];

  // ---- Polaris -------------------------------------------------------------
  // Models come from the bearing dataset (polaris-bearing-fitment.js). By default
  // they route to the wheel-bearing PRODUCT. Models listed in POLARIS_COLLECTIONS
  // route to their own fitment COLLECTION instead (each contains the bearing
  // products PLUS model-specific parts). Keyed by the bearing-data model name;
  // optional start/end override the bearing years where the collection's range
  // is narrower (e.g. Turbo S ended in 2021).
  var POLARIS_BEARING = 'axiom-supply-polaris-lifetime-warranty-wheel-bearing-rzr-xp-2014-2023';
  var RZR_S_800 = '2009-2014-polaris-rzr-s-800-polaris-rzr-4-800-2010-2014';
  var RZR_XP = '2014-2024-rzr-xp-1k-xp-turbo'; // titled "2014 - 2026 RZR XP 1k/XP Turbo"
  var RZR_TURBO_S = '2018-2021-rzr-xp-turbo-s';
  var RZR_PRO_XP = '2021-2026-rzr-pro-xp'; // titled "2020 - 2026 RZR PRO XP"
  var GENERAL = '2016-2026-polaris-general';
  var XPEDITION = '2024-2026-polaris-xpedition';
  var POLARIS_COLLECTIONS = {
    'RZR S 800': { handle: RZR_S_800 },
    'RZR 4 800': { handle: RZR_S_800 },
    'RZR XP 1000': { handle: RZR_XP },
    'RZR XP 4 1000': { handle: RZR_XP },
    'RZR XP Turbo': { handle: RZR_XP },
    'RZR XP 4 Turbo': { handle: RZR_XP },
    'RZR Turbo S': { handle: RZR_TURBO_S, end: 2021 },
    'RZR Turbo S 4': { handle: RZR_TURBO_S, end: 2021 },
    'RZR Pro XP': { handle: RZR_PRO_XP },
    'RZR Pro XP 4': { handle: RZR_PRO_XP },
    'General': { handle: GENERAL },
    'General 4': { handle: GENERAL },
    'General XP 1000': { handle: GENERAL },
    'General XP 4 1000': { handle: GENERAL },
    'Xpedition XP': { handle: XPEDITION },
    'Xpedition XP 5': { handle: XPEDITION },
    'Xpedition ADV': { handle: XPEDITION },
    'Xpedition ADV 5': { handle: XPEDITION }
  };

  // Polaris models that are NOT in the bearing dataset (they use different
  // bearings) but have their own fitment collection (added 2026-09-28). They are
  // inserted right after the RZR bearing models so the RZR family stays grouped.
  var POLARIS_EXTRA = [
    F('Polaris', 'RZR Pro R', '', 2022, 2026, '2022-2026-rzr-pro-r'),
    F('Polaris', 'RZR Pro R 4', '', 2022, 2026, '2022-2026-rzr-pro-r'),
    F('Polaris', 'RZR Turbo R', '', 2022, 2026, '2022-2026-rzr-turbo-r-pro-s'),
    F('Polaris', 'RZR Turbo R 4', '', 2022, 2026, '2022-2026-rzr-turbo-r-pro-s'),
    F('Polaris', 'RZR Pro S', '', 2024, 2026, '2022-2026-rzr-turbo-r-pro-s'),
    F('Polaris', 'RZR Pro S 4', '', 2024, 2026, '2022-2026-rzr-turbo-r-pro-s')
  ];

  var polaris = [];
  var lastRzr = -1;
  (window.AXIOM_POLARIS_BEARING || []).forEach(function (e) {
    var col = POLARIS_COLLECTIONS[e.model];
    var start = (col && col.start) || e.start;
    var end = (col && col.end) || e.end;
    if (col) {
      polaris.push({ make: 'Polaris', model: e.model, trim: '', start: start, end: end, handle: col.handle });
    } else {
      polaris.push({ make: 'Polaris', model: e.model, trim: '', start: start, end: end, handle: POLARIS_BEARING, prod: true });
    }
    if (e.group === 'RZR') lastRzr = polaris.length - 1;
  });
  Array.prototype.splice.apply(polaris, [lastRzr + 1, 0].concat(POLARIS_EXTRA));

  window.AXIOM_FITMENT = DATA.concat(polaris);
  window.AXIOM_FITMENT_MAKE_ORDER = ['RAM', 'Ford', 'Chevy / GMC', 'Jeep', 'Toyota', 'Lexus', 'Hummer', 'Polaris', 'Can-Am', 'Kawasaki'];
})();
